export function normalizePixe(input: string | number | null | undefined): number {
  const n = typeof input === 'number' ? input : Number(String(input ?? '0').replace(/,/g, ''))
  if (!Number.isFinite(n)) return 0
  // Heuristic: if an upstream source sends micro‑PIXE (1e6), scale down
  // Shown symptom: 199,999,999,880,507.10 should be ~199,999,999.19 (÷ 1e6)
  if (n >= 1e12) return n / 1e6
  return n
}

export function formatPixeFull(input: string | number | null | undefined, decimals = 2): string {
  const v = normalizePixe(input)
  return v.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
}
